<template>
  <div class="container">
    <a-form
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 10 }"
    >
      <a-form-item
        label="业务流水号"
        has-feedback
      >
        <span>{{ dataSourceInfo.applyNo }}</span>
      </a-form-item>
      <a-form-item
        label="投保申请数据"
        has-feedback
      >
        <span class="no-wrap">{{ dataSourceInfo.applyData }}</span>
      </a-form-item>
      <a-form-item
        label="数字信封加密"
        has-feedback
      >
        <span class="no-wrap">{{ dataSourceInfo.digitalEnvelope }}</span>
      </a-form-item>
      <div class="decrypt-actions">
        <a-button
          type="primary"
          size="large"
          :loading="caLoading"
          :disabled="bztLoading"
          @click="btnCA"
        >
          CA锁解密
        </a-button>
        <a-button
          type="primary"
          size="large"
          class="btnBzt"
          :loading="bztLoading"
          :disabled="caLoading"
          @click="btnBzt"
        >
          全国CA互认解密
        </a-button>
      </div>
    </a-form>

    <a-modal
      v-model="qrcodeVisible"
      title="请使用标证通扫码解密"
      centered
      :footer="null"
      :mask-closable="false"
      @cancel="stopBztPolling"
    >
      <img
        v-show="qrcodeImage"
        :src="qrcodeImage"
        class="qrcode-image"
        alt="标证通二维码"
      >
      <div
        v-if="!qrcodeImage"
        class="qrcode-loading"
      >
        二维码生成中...
      </div>
    </a-modal>
  </div>
</template>

<script>
/* global iWebNet, ThrowEx */
import apis from '@/api/insurePreFoShan.js';
const {
  buildFoshanRequestData,
  decryptWithLocalOcx,
  decryptWithFallback,
} = require('./decryptors');
const {
  extractBztQrcode,
  isBztPollingActive,
} = require('./bzt');

function FoshanEpCaObj(breakOnError) {
  if (breakOnError && !this.CAInit()) {
    ThrowEx('CA证书读取异常,请先插好CA锁!');
  }
}

FoshanEpCaObj.prototype.CAType = '376';
FoshanEpCaObj.prototype.CAInit = function() {
  try {
    const initData = iWebNet.Prepare('CAInit');
    const initResult = iWebNet.PostMsg(initData);
    return initResult.body.qrstatus === '1';
  } catch (ex) {
    ThrowEx('请使用IE浏览器，并确保驱动已正确安装!');
  }
};
FoshanEpCaObj.prototype.Encrypt = function(OrgData) {
  try {
    const EncData = {
      body: {
        qrinfo: {
          ext: { CertPath: '' },
          decryptobjects: [{ org: OrgData }],
          qrcodetype: 'Encrypt',
        },
      },
    };
    const rtnVRRes = iWebNet.PostMsg(EncData);
    if (rtnVRRes) {
      return rtnVRRes.body.qrinfo.decryptobjects[0].encryed;
    } return '';
  } catch (ex) {
    ThrowEx('加密出现异常，请检查锁是否插好!');
  }
};
FoshanEpCaObj.prototype.Decrypt = function(JiaMiData) {
  try {
    const DecData = {
      body: {
        qrinfo: {
          decryptobjects: [{ encryed: JiaMiData }],
          qrcodetype: 'Decrypt',
        },
      },
    };
    const rtnDec = iWebNet.PostMsg(DecData);
    if (rtnDec) return rtnDec.body.qrinfo.decryptobjects[0].org;
    return '';
  } catch (ex) {
    ThrowEx('解密过程出现异常，可能的原因：' + ex.description);
  }
};
export default {
  name: 'InsurePre',
  components: {

  },
  data() {
    return {
      dataSourceInfo: {
        applyno: '',
      },
      caLoading: false,
      bztLoading: false,
      qrcodeVisible: false,
      qrcodeImage: '',
      qrcodeid: '',
      bztTimer: null,
      bztGeneration: 0,
    };
  },
  beforeDestroy() {
    this.stopBztPolling();
  },
  methods: {
    unwrap(response) {
      const body = response && response.data;
      return body && body.data && typeof body.data === 'object' ? body.data : (body || {});
    },
    notifyError(error, fallback) {
      const responseMessage = error && error.response && error.response.data && error.response.data.message;
      const message = responseMessage || (error && error.message) || fallback;
      this.$notification.error({ message });
    },
    redirectIfInsured(data) {
      if (String(data && data.toInsure) !== '1') return false;
      if (!data.redirectUrl) {
        this.$notification.error({ message: '投保跳转地址为空' });
        return true;
      }
      window.location.href = data.redirectUrl;
      return true;
    },
    decryptWithIWebNet(encryptedEnvelope) {
      iWebNet.Init(376);
      new FoshanEpCaObj(true);
      return FoshanEpCaObj.prototype.Decrypt(encryptedEnvelope);
    },
    async btnCA() {
      if (this.bztLoading) return;
      this.caLoading = true;
      try {
        await this.Inits();
      } finally {
        this.caLoading = false;
      }
    },
    async Inits() {
      try {
        const predata = this.unwrap(await apis.getPredata({ orderNo: this.$route.query.orderNo }));
        if (this.redirectIfInsured(predata)) return;
        this.dataSourceInfo = predata;
        const decryptedEnvelopeRaw = await decryptWithFallback(
          this.dataSourceInfo.digitalEnvelope,
          {
            localDecrypt: decryptWithLocalOcx,
            iwebDecrypt: encryptedEnvelope => this.decryptWithIWebNet(encryptedEnvelope),
          }
        );
        const requestData = buildFoshanRequestData(
          this.dataSourceInfo.applyNo,
          decryptedEnvelopeRaw
        );
        this.dataSourceInfo.digitalEnvelope = decryptedEnvelopeRaw;
        const result = this.unwrap(await apis.postDigitalEnvelope({
          type: requestData.type,
          applyno: requestData.applyno,
          encryptkey: requestData.encryptkey,
        }));
        this.redirectIfInsured(result);
      } catch (error) {
        this.notifyError(error, 'CA解密失败，请稍后重试');
      }
    },
    async btnBzt() {
      if (this.caLoading) return;
      this.stopBztPolling();
      const generation = this.bztGeneration;
      this.bztLoading = true;
      this.qrcodeVisible = true;
      try {
        const result = this.unwrap(await apis.getBztQrcode({ orderNo: this.$route.query.orderNo }));
        if (generation !== this.bztGeneration || !this.qrcodeVisible) return;
        if (this.redirectIfInsured(result)) {
          this.stopBztPolling();
          return;
        }
        const qrInfo = extractBztQrcode(result);
        this.qrcodeid = qrInfo.qrcodeid;
        if (!this.isBztActive(generation)) return;
        this.qrcodeImage = qrInfo.image;
        this.pollBztResult(generation);
      } catch (error) {
        if (generation !== this.bztGeneration) return;
        this.stopBztPolling();
        this.notifyError(error, '标证通二维码生成失败');
      }
    },
    async pollBztResult(generation) {
      if (!this.isBztActive(generation)) return;
      if (this.bztTimer) window.clearTimeout(this.bztTimer);
      try {
        const result = this.unwrap(await apis.getBztQueryResult({
          orderNo: this.$route.query.orderNo,
          qrcodeid: this.qrcodeid,
        }));
        if (!this.isBztActive(generation)) return;
        if (this.redirectIfInsured(result)) {
          this.stopBztPolling();
          return;
        }
        if (String(result.qrstatus) === '03') {
          this.stopBztPolling();
          this.$notification.warning({ message: result.message || '标证通二维码已失效，请重新发起解密' });
          return;
        }
        this.bztTimer = window.setTimeout(() => this.pollBztResult(generation), 10000);
      } catch (error) {
        if (generation !== this.bztGeneration) return;
        this.stopBztPolling();
        this.notifyError(error, '标证通解密状态查询失败');
      }
    },
    isBztActive(generation) {
      return isBztPollingActive(generation, this.bztGeneration, this.qrcodeVisible, this.qrcodeid);
    },
    stopBztPolling() {
      this.bztGeneration += 1;
      if (this.bztTimer) window.clearTimeout(this.bztTimer);
      this.bztTimer = null;
      this.qrcodeVisible = false;
      this.qrcodeImage = '';
      this.qrcodeid = '';
      this.bztLoading = false;
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
}

.main {
  padding: 30px 50px 95px;
}

.pickCompany {
  margin-top: 90px;
}

.operate {
  margin-top: 80px;
}

// .notice-dialog {
::v-deep .ant-modal {
  width: 960px !important;
}

::v-deep .ant-modal-content {
  width: 960px !important;
  height: 680px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}

::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
}

::v-deep .ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
}

::v-deep .ant-modal-footer button {
  padding: 12px 26px;
  height: auto;
  font-size: 16px;
  line-height: 1;
  margin-left: 50px;
}

// }
.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
.no-wrap {
  word-wrap: break-word;
}
.decrypt-actions {
  margin-top: 100px;
  display: flex;
  justify-content: center;
}
.btnBzt {
  margin-left: 24px;
}
.qrcode-image {
  display: block;
  width: 320px;
  height: 320px;
  margin: 20px auto;
}
.qrcode-loading {
  padding: 140px 0;
  text-align: center;
  color: #999;
}
</style>
